import { render, staticRenderFns } from "./listas.vue?vue&type=template&id=c8efd440&scoped=true"
import script from "./listas.vue?vue&type=script&lang=js"
export * from "./listas.vue?vue&type=script&lang=js"
import style0 from "./listas.vue?vue&type=style&index=0&id=c8efd440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8efd440",
  null
  
)

export default component.exports